import React from "react";
import {Button, DatePicker, Modal, Select} from "antd";
import moment from "moment";

const Option = Select.Option;
export default function AddNewSubscription( { props } ) {

    function disabledDate(current) {
        return current && current < moment().endOf('day');
    }

  return <>
    <div className={'d-flex w-100percent justify-content-end'}>
      <Button type='primary'
              onClick={props.showModal}>
        Create New Subscription
      </Button>
      <Modal
          visible={props.visible}
          title="Create New Subscription"
          onOk={props.handleCancel}
          onCancel={props.handleCancel}
          footer={[
            <Button key="back"
                    onClick={props.handleCancel}>
              Return
            </Button>,
            <Button type="primary"
                    key="submit"
                    className={'btn btn-success'}
                    loading={props.loading}
                    onClick={props.createNewSubscription}>
              Submit
            </Button>
          ]}>

        <div className="d-flex flex-col">
          <div className="p-2">
            <span>Users</span>
            <Select
                value={props.selectedUser}
                onChange={(e) => {
                  props.setUser(e)
                }}
                size="default"
                placeholder={'Select User'}
                showSearch
                loading={props.usersLoading}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                className="w-100percent ant-input mw-150">
              {props.users?.map((mode, index) => (
                  <Option value={mode.id} key={index}>
                    {mode.email}
                  </Option>
              ))}
            </Select>
          </div>
        </div>

        <div className="d-flex flex-col">
          <div className="p-2">
            <span>Access Group</span>
            <Select
                value={props.selectedAccessGroup}
                onChange={(e) => {
                  props.setAccessGroup(e)
                }}
                size="default"
                showSearch
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                }
                placeholder={'Select Access Group'}
                className="w-100percent ant-input mw-150">
              {props.accessGroups?.map((mode, index) => (
                  <Option value={mode.sku} key={index}>
                    {mode.name}
                  </Option>
              ))}
            </Select>
          </div>
        </div>

          <div className="p-2">
              <span>Start Date</span>
              <div>
                  <DatePicker value={props.selectedDate && moment(props.selectedDate, 'DD/MM/YYYY')}
                              format={'DD/MM/YYYY'}
                              // disabledDate={disabledDate}
                              onChange={(e) => {
                                  props.setNewDate(e)
                              }}/>
              </div>
          </div>
      </Modal>
    </div>
  </>
}
